import React from 'react';
import { reasons } from '../data/content';
export function Proof() {
  return <section id="why-us" className="w-full bg-white py-16 lg:py-24" data-id="element-205" data-mp="7qbl8r168oob">
      <div className="mx-auto max-w-5xl px-5" data-id="element-206" data-mp="7q1x78zosrl9">
        <h2 className="font-display text-3xl uppercase text-forest-800 sm:text-4xl" data-id="element-207" data-mp="lqmchv6e85a0">
          Five reasons North County trusts Javier
        </h2>

        <ol className="mt-10 divide-y divide-forest-100 border-y border-forest-100" data-id="element-208" data-mp="grsxfybgk67q">
          {reasons.map(({
          icon: Icon,
          title,
          body
        }, index) => <li key={title} className="flex flex-col gap-4 py-6 sm:flex-row sm:items-start sm:gap-7" data-id="element-209" data-mp="3k91dqdqjey0c" data-mpi={index}>
              <span className="font-display text-4xl leading-none text-ember-500 sm:w-14" data-id="element-210" data-mp="2s0c6iipai75">
                {String(index + 1).padStart(2, '0')}
              </span>
              <Icon className="hidden h-7 w-7 shrink-0 text-forest-700 sm:block" aria-hidden="true" data-id="element-211" data-mp="36fs7un1ssumk" />
              <div data-id="element-212" data-mp="31hqri9vrb9es">
                <h3 className="font-display text-xl uppercase text-forest-800" data-id="element-213" data-mp="31g76k5z5oa6o">{title}</h3>
                <p className="mt-1 text-base leading-relaxed text-ink-700" data-id="element-214" data-mp="28mwbtq60tguw">{body}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}